import React from 'react';
import { Message } from '@forwardfinancing/component-library';
import { trackPageView } from '@forwardfinancing/analytics-frontend-library/index';

class PageNotFoundPage extends React.Component {
  componentDidMount() {
    trackPageView({page: 'Page Not Found'});
  }

  render() {
    return (
      <div className="page-not-found column page">
        <Message
          mainMessage="Page Not Found"
          secondaryMessage="Sorry, we couldn't find the page you're looking for."
          buttonDisplayVal="Forward Financing Home"
          buttonLink="https://www.forwardfinancing.com"
        />
      </div>
    );
  }
}

export default PageNotFoundPage;
